module.exports = __webpack_public_path__ + "static/media/lance.788330c4.jpg";